import { ShoppingCart } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useCartStore, useCartItemCount } from '@/stores/cart-store'
import { cn } from '@/lib/utils'

interface CartIconProps {
  className?: string
}

export function CartIcon({ className }: CartIconProps) {
  const toggleCart = useCartStore(state => state.toggleCart)
  const itemCount = useCartItemCount()

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn('relative', className)}
      onClick={toggleCart}
      aria-label={`Shopping cart with ${itemCount} items`}
    >
      <ShoppingCart className="size-5" />
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 flex size-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </Button>
  )
}
